const compactNumberFormatter = new Intl.NumberFormat('pt-BR', {
  notation: 'compact',
  maximumFractionDigits: 1,
});

const wholeNumberFormatter = new Intl.NumberFormat('pt-BR');

const usdFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const shortDateFormatter = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit',
  month: '2-digit',
});

const shortDateTimeFormatter = new Intl.DateTimeFormat('pt-BR', {
  dateStyle: 'short',
  timeStyle: 'short',
});

export function formatCompactInteger(value: number): string {
  return compactNumberFormatter.format(value);
}

export function formatWholeNumber(value: number): string {
  return wholeNumberFormatter.format(value);
}

export function formatUsd(value: number): string {
  return usdFormatter.format(value);
}

export function formatPercent(value: number): string {
  return `${wholeNumberFormatter.format(Math.round(value))}%`;
}

export function formatDashboardDay(date: string): string {
  return shortDateFormatter.format(new Date(`${date}T12:00:00Z`));
}

export function formatDateTime(dateTime: string): string {
  return shortDateTimeFormatter.format(new Date(dateTime));
}
